type MenuExperiencePageProps = {
  params: {
    orderId?: string
  }
  location: {
    query: {
      collection?: string
      reload?: boolean
    }
  }
}

export const MenuExperiencePage = (_props: MenuExperiencePageProps) => null
